import { render, staticRenderFns } from "./CompanyInfo_UploadLedger.vue?vue&type=template&id=6d4f7c6f&scoped=true"
import script from "./CompanyInfo_UploadLedger.vue?vue&type=script&lang=js"
export * from "./CompanyInfo_UploadLedger.vue?vue&type=script&lang=js"
import style0 from "./CompanyInfo_UploadLedger.vue?vue&type=style&index=0&id=6d4f7c6f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d4f7c6f",
  null
  
)

export default component.exports